import catchCancel from 'helpers/catchCancel';

const getCropSeasonDetails = async (
  seasonId,
  setInitialValues,
  setPageError,
  setLoaded,
  fetchApi
) => {
  const { promise } = fetchApi.fetch(
    seasonId,
    undefined,
    undefined,
    undefined,
    true // ignoreCache
  );

  await promise
    .then(({ data }) => {
      const values = data;
      values.date = [new Date(data.startDate), new Date(data.endDate)];
      const cropzones = [];
      data.cropZones.forEach(cz => cropzones.push(cz.cropzoneId));
      values.cropZones = cropzones;
      values.propertiesGroupBy = 'property';
      setInitialValues(values);
    })
    .catch(catchCancel)
    .catch(err => {
      setInitialValues({});
      setPageError(err.response);
    })
    .finally(() => setLoaded(true));
};

export default getCropSeasonDetails;
